import { Instance, SnapshotOut, types } from "mobx-state-tree"

export const PaymentModel = types
  .model("Payment")
  .props({
    id: types.maybe(types.identifierNumber),
    pay_account: types.maybe(types.string),
    pay_type: types.maybe(types.number),
    user_id: types.maybe(types.number),
    bank_name: types.maybeNull(types.string),
    bank_branch: types.maybeNull(types.string),
    real_name: types.maybeNull(types.string),
    qr_code: types.maybeNull(types.string),
  })
  .views(() => ({}))
  .actions((self) => ({
    update(values: { [key: string]: any }) {
      for (const key in values) {
        self[key] = values[key]
      }
    },
  }))

type PaymentType = Instance<typeof PaymentModel>
export interface Payment extends PaymentType {}
type PaymentSnapshotType = SnapshotOut<typeof PaymentModel>
export interface PaymentSnapshot extends PaymentSnapshotType {}
export const createPaymentDefaultModel = () => types.optional(PaymentModel, {})
